module.exports = __webpack_public_path__ + "img/one-yellow-light.04150762.svg";